import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../service/user.service';
import { NotificationService } from 'src/app/services/notification.service';
import { ActionMessage, TypeMessage } from 'src/app/entity/enum/enum-notification';

@Component({
  selector: 'app-new-user',
  templateUrl: './new-user.component.html',
  styleUrls: ['./new-user.component.scss']
})
export class NewUserComponent implements OnInit {

  form: FormGroup;
  adm: boolean = false;
  isEdit: boolean = false;
  constructor(
    private fb: FormBuilder,
    private routerActivate: ActivatedRoute,
    private router: Router,
    private service: UserService,
    private notificationService: NotificationService,
  ) { }

  ngOnInit(): void {
    this.getUserPermission()
    this.createForm()
  }

  getUserPermission = async () => {
    await this.service.userIsAdmin().subscribe(adm => {
      if (adm) {
        this.adm = true;
        this.getData();
      }
      else this.backDash()

    })
  }
  createForm = () => {
    this.form = this.fb.group({
      id: [null],
      cwid: ['', Validators.required],
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      admin: [false, Validators.required]
    })
  }
  getForm() {
    const data = {
      id: this.form.controls.id.value ?? null,
      cwid: this.form.controls.cwid.value.toUpperCase(),
      user_name: this.form.controls.name.value,
      email: this.form.controls.email.value,
      admin: this.form.controls.admin.value,
    }

    return data;
  }
  getData() {
    let idUser = this.routerActivate.snapshot.params['id'];
    if (idUser !== undefined) {
      this.isEdit = true;
      this.service.getUserById(idUser)
        .then(res => {
          this.populateForm(res.data);
        })
        .catch(err => {
          console.error(err);
          this.notificationService.sendNotification(
            null,
            TypeMessage.SyncListEmpty,
            ActionMessage.Error
          );
        })

    } else {
      this.isEdit = false;
    }
  }
  populateForm(data) {
    console.log(data);

    this.form.controls.id.setValue(data.id)
    this.form.controls.cwid.setValue(data.cwid)
    this.form.controls.name.setValue(data.user_name)
    this.form.controls.email.setValue(data.email)
    this.form.controls.admin.setValue(data.admin)
  }


  backList() {
    this.router.navigateByUrl('adm/users/list');
  }
  saveUpdate() {

    this.saveOrUpdate();

  }
  saveOrUpdate() {
    if (this.form.invalid) {
      this.notificationService.sendNotification(
        null,
        TypeMessage.FormInvalid,
        ActionMessage.Info
      );
      return;
    }


    this.service.saveOrUpdate(this.getForm(), this.isEdit)
      .then(res => {
        this.notificationService.sendNotification(
          null,
          this.isEdit ? TypeMessage.Edit : TypeMessage.New,
          ActionMessage.Success
        );
        this.backList()
      })
      .catch(err => {
        console.error(err);
      })

  }
  edit() {
    throw new Error('Method not implemented.');
  }
  backDash() {
    this.router.navigateByUrl('/dashboard');
  }
}
